import {
  CreateDashboardWidgetDto,
  DashboardItem,
  DashboardWidgetDto,
} from '../../../../models/Dashboard';

export function rounded(value: number, digits: number = 2): string {
  const rounded2Digits = (value ?? 0).toFixed(digits);
  return Number(rounded2Digits).toLocaleString();
}

// Helper function to convert DashboardItem to WidgetDto
export const dashboardItemToWidgetDto = (
  item: DashboardItem
): CreateDashboardWidgetDto => {
  return {
    dashboardWidgetId: item.dashboardItemId,
    dashboardWidgetType: item.type,
    width: item.layout.width,
    height: item.layout.height,
    positionX: item.layout.x,
    positionY: item.layout.y,
    jsonContent: item.data && JSON.stringify(item.data), // Assuming data is part of the DashboardItem
  };
};

// Helper function to convert WidgetDto to DashboardItem
export const widgetDtoToDashboardItem = (
  widget: DashboardWidgetDto
): DashboardItem => {
  return {
    dashboardItemId: widget.dashboardWidgetId,
    type: widget.dashboardWidgetType,
    layout: {
      x: widget.positionX,
      y: widget.positionY,
      width: widget.width,
      height: widget.height,
    },
    data: widget.jsonContent && JSON.parse(widget.jsonContent),
  };
};

export function parsePowerBIData<T extends Record<string, any>>(
  input: string | T
): T | null {
  if (!input) return null; // Allow null as a valid return type
  if (typeof input === 'string') {
    try {
      const parsed = JSON.parse(input);
      return parsed as T; // Explicitly cast the parsed object to type T
    } catch (err) {
      console.log(`Invalid JSON string: ${(err as Error).message}`);
      return null; // Return null if parsing fails
    }
  }
  return input; // If input is already of type T, return it directly
}
